import Vue from 'vue/dist/vue.js'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import zh from './locales/zh'

Vue.use(VueI18n)

const messages = {
  en,
  zh
}

// Check browser language
const getBrowserLanguage = () => {
  const language = navigator.language.toLowerCase()
  if (language.indexOf('zh') >= 0) {
    return 'zh'
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getBrowserLanguage(), // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
})

export default i18n
